<template>
  <button class="src_select_btn album">
    <div class="src_select_btn__before" :style="{paddingTop: aspectRatioStyle}" />
    <div class="btn__wrapper">
      <slot />
    </div>
  </button>
</template>

<script>
  export default {
    props: {
      aspectRatioStyle: {
        type: String,
        default: 'calc(137 / 252 * 100%)'
      }
    }
  }
</script>

<style scoped lang="scss">
  button {
    cursor: pointer;
    padding: 0;
    appearance: none;
    outline: none;
    background-color: transparent;
    border: none;
  }
  .src_select_btn {
    position: relative;
    border-radius: 3px;
    outline: #000 solid 1px;
    .src_select_btn__before {
      display: block;
      content: '';
    }
    .btn__wrapper {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
